import { NEW_TICKET_PROPERTY_ORDER } from '@nile/mangifera/src/Constants/Tickets';
import { TicketDetailForm } from '@nile/mangifera/src/Containers/FormContainers';
import React, { Component } from 'react';
import styled from 'styled-components';

const StyledTicketForm = styled.div`
  background: #ffffff;

  position: relative;

  .form-wrapper {
    width: 100% !important;
  }

  .TicketSearch {
    box-shadow: 1px -1px 3px 0px rgba(0, 0, 0, 0.75);
    height: 52px;
    margin-left: 2px;
    background: #ffffff;
    z-index: 999;
    position: inherit;
  }
`;

class TicketForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticket: {}
    };
  }

  updateSelection = (key, value) => {
    this.props.updateField(key, value);
    // this.setState({
    //   ticket: {
    //     ...this.state.ticket,
    //     [key]: value
    //   }
    // })
  };

  updateProperties = (properties) => {
    this.props.updateProperties(properties);
  };

  render() {
    const { updateField, styles, ticket } = this.props;
    return (
      <StyledTicketForm styles={styles}>
        {/* <div className="TicketSearch"></div> */}
        <TicketDetailForm
          propertyOrder={NEW_TICKET_PROPERTY_ORDER}
          updateSelection={this.updateSelection}
          updateProperties={this.updateProperties}
          ticket={ticket}
          creationForm
        />
      </StyledTicketForm>
    );
  }
}

export default TicketForm;
